import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

import { TITLE_OFFICIAL_REPORTS_BLOCK, DESCRIPTIONS_OFFICIAL_REPORTS_BLOCK } from '../../../constants/reportLayouts';
import Button from '../../shared/Button';

import styles from './styles.scss';

const OfficialReports = ({ disabled = false, companyId }) => {
  return (
    <Container fluid className={`py-4 mb-4 ${styles.reportContainer}`}>
      <Row>
        <Col className={`pb-2`} md={9}>
          <div className={`mt-2 ${styles.content}`}>
            <img src="/aarst-ansi-logo.png" className={`mr-4 mb-3 ${styles.logo}`} />
            <div>
              <div className={`mb-3 ${styles.header}`}>
                <h5>
                  <strong>{TITLE_OFFICIAL_REPORTS_BLOCK}</strong>
                </h5>
              </div>
              <span>{DESCRIPTIONS_OFFICIAL_REPORTS_BLOCK[0]}</span>
              <a href="https://standards.aarst.org/MAH-2019/index.html" target="_blank" rel="noopener noreferrer">
                Click here to review standard.
              </a>
              <span>{DESCRIPTIONS_OFFICIAL_REPORTS_BLOCK[1]}</span>
            </div>
          </div>
        </Col>
        <Col className={`${styles.actionButtons}`} md={3}>
          <Link to={`reports/${companyId}/coverLetter`}>
            <Button kind="primary" disabled={disabled} className="mr-2 ml-2 mb-2">
              <i className="fa fa-edit mr-2" />
              Cover Letter
            </Button>
          </Link>
          <Link to={`reports/${companyId}/reportContent`}>
            <Button kind="primary" disabled={disabled} className="mr-2 ml-2 mb-2">
              <i className="fa fa-edit mr-2" />
              Report Content
            </Button>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

OfficialReports.propTypes = {
  disabled: PropTypes.bool,
  companyId: PropTypes.number,
};

export default OfficialReports;



// WEBPACK FOOTER //
// src/components/reportManagement/OfficialReports/index.jsx